// import { createSelector, createStructuredSelector } from "reselect";
import _ from "lodash";

// TODO: utilise createSelector for memoization

// input:
export const makeInputSelector = state => {
  return { ...state.inputReducer.input };
};

// For Interests, Skills and Career
export const makeAttributeSelector = ATTRIBUTE => state => {
  return {
    attributes: makeAttributeListSelector(ATTRIBUTE)(state),
    attributeRef: makeAttributeRefSelector(ATTRIBUTE)(state),
    userAttributes: makeAttributeUserSelector(ATTRIBUTE)(state)
  };
};

// for personality
export const makePersonalitySelector = () => state => {
  return {
    userPersonality: makeUserPersonalitySelector()(state),
    personalityList: makePersonalityList()(state)
  };
};

// attribute
export const makeAttributeListSelector = ATTRIBUTE => state => {
  if (_.isEmpty(state) || _.isEmpty(ATTRIBUTE)) {
    console.error("Attribute selector not instantiated properly.");
    return [];
  }
  const attributeOb = state.inputReducer.input.attributes[ATTRIBUTE];
  return Object.values(attributeOb);
};
export const makeAttributeRefSelector = ATTRIBUTE => state => {
  if (_.isEmpty(state) || _.isEmpty(ATTRIBUTE)) {
    console.error("Attribute ref selector not instantiated properly.");
    return {};
  }
  return state.inputReducer.input.attributes[ATTRIBUTE];
};
export const makeAttributeUserSelector = ATTRIBUTE => state => {
  if (_.isEmpty(state) || _.isEmpty(ATTRIBUTE)) {
    console.error("Attribute user selector not instantiated properly.");
    return [];
  }

  const userAttributes =
    state[`${ATTRIBUTE.toLowerCase()}sReducer`][
      `user${_.startCase(ATTRIBUTE.toLowerCase())}s`
    ] || [];
  return userAttributes.map(attr => attr.toString());
};

// list
export const makeUserPersonalitySelector = () => state => {
  if (_.isEmpty(state)) {
    console.error("makeUserPersonalitySelector instantiated properly.");
    return [];
  }
  const userList = state.personalityReducer.userPersonality;
  return [...userList];
};

export const makePersonalityList = () => state => {
  if (_.isEmpty(state)) {
    console.error("makePersonalityRef not instantiated properly.");
    return {};
  }
  return Object.values(state.inputReducer.input.personality_attributes);
};
